/**
 * @license
 * Copyright Akveo. All Rights Reserved.
 * Licensed under the MIT License. See License.txt in the project root for license information.
 */
export const environment = {
  production: false,
  develop: false,
  apiBaseUrl: 'https://apidev.tiendadepuntos.com',
  frontendBaseUrl: 'https://demo.tiendadepuntos.com',
  oauthClientId: '2',
  oauthClientSecret: 'E6dtat3La5HwLr0o13pKcboIVUWOo5Ohwd6kv3ye',
  mercadoPagoPublicKey: 'TEST-17a8089f-406c-4028-9f75-3f8ca437e741',
  qrBucket: 'https://puntos-qrs.s3-us-west-2.amazonaws.com',
};
